import { useCallback, useEffect, useState } from "react";
import api from "@/api"; // общий axios-инстанс

/**
 * Хук для плоского справочника единиц измерения.
 * Эндпоинты: GET /units, POST /units {name}, PUT /units/:id {name}, DELETE /units/:id
 */
export default function useUnits() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/units");
      const list = Array.isArray(res.data) ? res.data : [];
      setData(list);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const reload = useCallback(fetchList, [fetchList]);

  const create = useCallback(async (name) => {
    await api.post("/units", { name });
  }, []);

  const updateName = useCallback(async (id, name) => {
    // оптимистичное обновление
    setData((prev) => prev.map((x) => (x._id === id ? { ...x, name } : x)));
    await api.put(`/units/${id}`, { name });
  }, []);

  const remove = useCallback(async (id) => {
    await api.delete(`/units/${id}`);
  }, []);

  return { data, loading, reload, create, updateName, remove };
}
